import { useEffect } from "react";

import { useCommentsStore } from "../stores/commentStore";

export const useKeyboardHandle = () => {
  const { setIsInAddCommentMode, setOpenCommentId, setIsNewCommentOpen } = useCommentsStore();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.repeat) {
        return;
      }

      if (event.shiftKey && event.ctrlKey) {
        setIsInAddCommentMode(true, { source: "keyboard_shortcut" });
      }
      if (event.key === "Escape") {
        setOpenCommentId(undefined);
        setIsNewCommentOpen(false);
        setIsInAddCommentMode(false, { source: "keyboard_shortcut" });
      }
    };

    const handleKeyUp = (event: KeyboardEvent) => {
      if (event.shiftKey || event.ctrlKey) {
        setIsInAddCommentMode(false, { source: "keyboard_shortcut" });
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [setIsInAddCommentMode, setOpenCommentId, setIsNewCommentOpen]);
};
